import { call, put, takeLatest } from 'redux-saga/effects';
import { CHECK_PUSH, PUSH_WORKER_URL, TURN_OFF_PUSH, TURN_ON_PUSH } from './constants';
import { setPushStatus } from './actions';
import { browserPushEnv, keyBytes, pushStatus } from './pushStatus';
import pushService from '../services/push';

/** This browser's push subscription, through the service worker, or null. */
function* currentSubscription() {
  const registration = yield call([navigator.serviceWorker, navigator.serviceWorker.register], PUSH_WORKER_URL);
  yield call(() => navigator.serviceWorker.ready);
  return yield call([registration.pushManager, registration.pushManager.getSubscription]);
}

function* status() {
  const env = browserPushEnv();
  const subscription = env.hasPush ? yield call(currentSubscription) : null;
  return pushStatus({ ...env, subscribed: !!subscription });
}

function* checkPushTask() {
  try {
    const key = yield call(pushService.key);
    yield put(setPushStatus(key ? yield call(status) : 'server-off'));
  } catch (error) {
    yield put(setPushStatus('unsupported', error.message));
  }
}

// iOS shows the permission prompt only after a tap, so this runs from the button.
function* turnOnPushTask() {
  try {
    const key = yield call(pushService.key);
    const permission = yield call([window.Notification, window.Notification.requestPermission]);
    if (permission !== 'granted') {
      yield put(setPushStatus(yield call(status)));
      return;
    }
    const registration = yield call([navigator.serviceWorker, navigator.serviceWorker.register], PUSH_WORKER_URL);
    yield call(() => navigator.serviceWorker.ready);
    const subscription = yield call([registration.pushManager, registration.pushManager.subscribe], {
      userVisibleOnly: true,
      applicationServerKey: keyBytes(key),
    });
    yield call(pushService.subscribe, subscription.toJSON());
    yield put(setPushStatus('on'));
  } catch (error) {
    yield put(setPushStatus(yield call(status), `Couldn't turn notifications on: ${error.message}`));
  }
}

function* turnOffPushTask() {
  try {
    const subscription = yield call(currentSubscription);
    if (subscription) {
      yield call(pushService.unsubscribe, subscription.endpoint);
      yield call([subscription, subscription.unsubscribe]);
    }
    yield put(setPushStatus('off'));
  } catch (error) {
    yield put(setPushStatus(yield call(status), `Couldn't turn notifications off: ${error.message}`));
  }
}

function* checkPushWatcher() {
  yield takeLatest(CHECK_PUSH, checkPushTask);
}

function* turnOnPushWatcher() {
  yield takeLatest(TURN_ON_PUSH, turnOnPushTask);
}

function* turnOffPushWatcher() {
  yield takeLatest(TURN_OFF_PUSH, turnOffPushTask);
}

export default [
  checkPushWatcher,
  turnOnPushWatcher,
  turnOffPushWatcher,
];
